import { StoreContext } from '@src/Store/Store.context';
import axios from 'axios';
import { useContext } from 'react';

/**
 *
 * @param idempotencyId is the PageName
 */
const AxiosInstance = (idempotencyId: string, baseUrl: string) => {
  const store = useContext(StoreContext);
  const instance = axios.create({
    baseURL: baseUrl || process.env.API_URL,
    timeout: 30000,
    headers: { checksum: process.env.CHECKSUM || '' }
  });
  instance.interceptors.request.use(
    function (config) {
      if (!config || !config.headers) {
        return;
      }
      if (store.UserStore.token) {
        config.headers.Authorization = `Bearer ${store.UserStore.token}`;
      }
      if (idempotencyId) {
        store.IdempotencyKeyStore.getIdempotencyKeyById(idempotencyId).then(
          (result) => {
            if (config && config.headers && result)
              config.headers['x-idem-key'] = result;
          }
        );
      }
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );
  return instance;
};

export default AxiosInstance;
